import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { API_URL } from "../../configurations/server-config";
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class ColissessionService {
  constructor(private http: HttpClient, private datepipe: DatePipe) {}

  getAllSession(page = 0, size = 100): any {
    return this.http.get(`${API_URL}/session?page=${page}&size=${size}`);
  }

  getAllSessionColisOrGuichet(
    sessionid: any,
    type: any,
    page = 0,
    size = 100
  ): any {
    return this.http.get(
      `${API_URL}/sessioncollisguichet?page=${page}&size=${size}&sid=${sessionid}&ty=${type}`
    );
  }

  getAllSessionByType(
    type: any,
    page = 0,
    size = 100,
    sortby = null,
    orderby = null
  ): any {
    return this.http.get(
      `${API_URL}/sessionbytype?page=${page}&size=${size}&ty=${type}&sortby=${sortby}&direction=${orderby}`
    );
  }

  getsessiondetail(id: string): any {
    return this.http.get(`${API_URL}/sessiondetail?p=${id}`);
  }

  getAllUserSession(page = 0, size = 100, id: any): any {
    return this.http.get(`${API_URL}/session/${id}?page=${page}&size=${size}`);
  }

  updateSessionType(type: any, sessionid: any): any {
    return this.http.post(
      `${API_URL}/sessiontype?type=${type}&sid=${sessionid}`,
      null
    );
  }

  getAllsessionDate(): any {
    return this.http.get(`${API_URL}/getsessionopendate`);
  }

  getAllsessionUser(): any {
    return this.http.get(`${API_URL}/getsessionuser`);
  }

  filtersession(
    user: any = null,
    date: any = null,
    page = 0,
    size = 100,
    sortby = null,
    orderby = null
  ): any {
    if (date != null) {
      date = this.datepipe.transform(date, "yyyy-MM-dd");
    }
    return this.http.get(
      `${API_URL}/filtersession?user=${user}&start=${date}&page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`
    );
  }

  filtersessionguichet(
    user: any = null,
    date: any = null,
    page = 0,
    size = 100,
    sortby = null,
    orderby = null
  ): any {
    if (date != null) {
      date = this.datepipe.transform(date, "yyyy-MM-dd");
    }
    return this.http.get(
      `${API_URL}/filtersessionguichet?user=${user}&start=${date}&page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`
    );
  }

  updateSessionStatus(sessionid: any): any {
    return this.http.post(
      `${API_URL}/updatesessionstatus?id=${sessionid}`,
      null
    );
  }

  // check colis duplicate in session
  getAllUserColisDuplicateSession(id: any): any {
    return this.http.get(`${API_URL}/colisduplicate?id=${id}`);
  }

  // check colis duplicate in session
  getAllUserPassengerTicketDuplicateSession(id: any): any {
    return this.http.get(`${API_URL}/passagervoyageduplicate?id=${id}`);
  }

  getReportOfTripInSession(id: any): any {
    return this.http.get(`${API_URL}/raportvoyagelistinsession?id=${id}`);
  }
}
